<template>
  <van-dialog v-model="show"
              :class=" className + ' unicom-dialog'"
              :title="title"
              :show-cancel-button="showCancel"
              :show-confirm-button="showConfirm"
              :confirm-button-text="confirmLable"
              :cancel-button-text="cancelLable"
              :overlay="overlay"
              :close-on-click-overlay="closeoverlay"
              @confirm="confirm"
              @cancel="$emit('cancelDialog')"
              :before-close="beforeClose">
    <slot></slot>
  </van-dialog>
</template>

<script>
export default {
  name: 'unicomDialog',
  props: {
    title: {
      type: String,
      default: ''
    },
    confirmLable: {
      type: String,
      default: '确定'
    },
    cancelLable: {
      type: String,
      default: '取消'
    },
    showConfirm: {
      type: Boolean,
      default: true
    },
    showCancel: {
      type: Boolean,
      default: false
    },
    overlay: {
      type: Boolean,
      default: true
    },
    closeoverlay: {
      type: Boolean,
      default: false
    },
    beforeClose: {
      type: Function
    },
    confirm: {
      type: Function,
      default: () => {
        return () => {
        }
      }
    },
    className: {
      type: String,
      default: ''
    },
    cancel: {
      type: Function,
      default: () => {
        return () => {
        }
      }
    },
    message: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      show: true
    }
  },
  methods: {
  }
}
</script>

<style lang="less">
.unicom-dialog {
  p {
    padding: 0.2rem 0.4rem;
    color: #666666;
    font-size: 0.28rem;
    .span {
      color: #002411;
    }
  }
  .van-button__text {
    color: #036bd6;
  }
}
</style>
